'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function MerchantLinks({ merchants, routes }) {
  return (
    merchants.length > 0 &&
    h(
      '.merchant-links',
      h(
        '.merchant-links-inner',
        {
          'data-bhw': 'PopularStores',
        },
        [
          h(
            'h2.merchant-links-title',
            h(Translate, 'modules.shared.TopBrands')
          ),
          h(
            'ul.merchant-links-list',
            merchants.map(merchant =>
              h(
                'li.merchant-links-item',
                h(
                  'a',
                  {
                    className: 'merchant-links-link',
                    href: routes.merchant.show.replace(
                      '{merchantSlug}',
                      merchant.merchantSlug
                    ),
                    'data-bhc': `store:${merchant.merchantSlug}`,
                  },
                  merchant.merchantName
                )
              )
            )
          ),
        ]
      )
    )
  );
}

module.exports = MerchantLinks;
